// BM-H398 - s9_funeral. `include_funeral_wishes_clause` drives C-19,
// `include_donation_clause` drives C-20-donation. Both explicit opt-ins.
// BM-H3378 - include_donation_clause is now derived from the two
// independent donation wishes below, not set directly by the client.

import { QuestionRow, SectionIntro, Select, TextArea, YesNo, sectionProps } from "./fields";

const DISPOSITION = [
  { value: "burial", label: "Burial" },
  { value: "cremation", label: "Cremation" },
  { value: "no_preference", label: "No preference" },
];

export default function S9Funeral({ section, setSection }) {
  const { s, set, nk, setNk } = sectionProps(section, setSection);
  return (
    <div data-testid="section-s9_funeral">
      <SectionIntro title="Funeral wishes">
        Optional, but almost everyone completes it. Your wishes spare your family the burden of guessing.
      </SectionIntro>
      <QuestionRow qid="s9_funeral.include_funeral_wishes_clause" label="Would you like your will to record your funeral wishes?" notKnown={nk("include_funeral_wishes_clause")} onNotKnown={(on) => setNk("include_funeral_wishes_clause", on)}>
        <YesNo testid="s9-include" value={s.include_funeral_wishes_clause} disabled={nk("include_funeral_wishes_clause")} onChange={(v) => set({ include_funeral_wishes_clause: v })} />
      </QuestionRow>
      {s.include_funeral_wishes_clause === true && (
        <>
          <QuestionRow qid="s9_funeral.disposition" label="Burial or cremation?">
            <Select testid="s9-disposition" value={s.disposition} options={DISPOSITION} onChange={(v) => set({ disposition: v })} />
          </QuestionRow>
          <QuestionRow qid="s9_funeral.instructions" label="Anything else about the funeral">
            <TextArea testid="s9-instructions" value={s.instructions} onChange={(v) => set({ instructions: v })} />
          </QuestionRow>
        </>
      )}
      {/* BM-H3378 - a single include_donation_clause yes/no could not
          distinguish two legally distinct routes under the Human Tissue
          Act 2004 s.3: organ/tissue donation for transplant (deemed-consent
          regime; the Will has no formal effect, only evidential value) and
          whole-body donation for anatomical examination (s.3(4)-(5)(c)
          permits written witnessed consent, but medical schools run their
          own acceptance process regardless). Solicitor decision, 1 Oct
          2026: split into two independent wishes - a client may choose
          either, both or neither. include_donation_clause is still
          derived and written (true if either wish is yes) so the engine's
          existing C-20-donation rule, and the clause itself, are
          unchanged: it correctly stays the generic, non-binding wish
          wording either way. */}
      <QuestionRow
        qid="s9_funeral.organ_donation_wish"
        label="Would you like your will to record a wish to donate organs or tissue for transplant?"
        notKnown={nk("organ_donation_wish")}
        onNotKnown={(on) => setNk("organ_donation_wish", on)}
        hint="This is a non-binding wish only. It does not register you as a donor - please also record your decision on the NHS Organ Donor Register and discuss it with your family. The Will clause is evidence of your wishes, never the consent mechanism."
      >
        <YesNo
          testid="s9-organ-donation"
          value={s.organ_donation_wish}
          disabled={nk("organ_donation_wish")}
          onChange={(v) => set({ organ_donation_wish: v, include_donation_clause: v === true || s.anatomical_donation_wish === true })}
        />
      </QuestionRow>
      <QuestionRow
        qid="s9_funeral.anatomical_donation_wish"
        label="Would you like your will to record a wish to donate your body for anatomical examination, teaching or research?"
        notKnown={nk("anatomical_donation_wish")}
        onNotKnown={(on) => setNk("anatomical_donation_wish", on)}
        hint="This is also a general, non-binding expression of wish. Formal consent for anatomical examination must be given in writing and witnessed before death, separately from this Will: please contact an appropriate medical school, complete that institution's own consent form, keep a copy of it with your Will, and tell your executors, family and doctor."
      >
        <YesNo
          testid="s9-anatomical-donation"
          value={s.anatomical_donation_wish}
          disabled={nk("anatomical_donation_wish")}
          onChange={(v) => set({ anatomical_donation_wish: v, include_donation_clause: s.organ_donation_wish === true || v === true })}
        />
      </QuestionRow>
    </div>
  );
}
